import Tab from '@mui/material/Tab'
import Tabs from '@mui/material/Tabs'
import type { SyntheticEvent } from 'react'
import type { TransactionTabValue } from '../../utils/transactionStatusUtils'
import { getTransactionTabLabel } from '../../utils/transactionStatusUtils'
import { RfhColors } from '../../config/florimixColors'
import { useTranslation } from 'react-i18next'

type TransactionTabsProps = {
  value: TransactionTabValue
  onChange: (newValue: TransactionTabValue) => void
  withTopMargin?: boolean
}

export const TransactionTabs = ({
  value,
  onChange,
  withTopMargin = false,
}: TransactionTabsProps) => {
  const { t } = useTranslation()

  const handleTabChange = (
    _event: SyntheticEvent,
    newValue: TransactionTabValue
  ) => {
    onChange(newValue)
  }

  return (
    <Tabs
      value={value}
      onChange={handleTabChange}
      sx={{
        borderBottom: 1,
        borderColor: 'divider',
        backgroundColor: RfhColors.white,
        paddingTop: theme => theme.spacing(2),
        paddingX: theme => theme.spacing(3),
        marginTop: theme => (withTopMargin ? theme.spacing(2) : 0),
      }}
    >
      <Tab
        value='open'
        label={getTransactionTabLabel('open', t)}
        sx={{
          fontFamily: value === 'open' ? 'HalyardBold' : 'HalyardDisplay',
        }}
      />
      <Tab
        value='closed'
        label={getTransactionTabLabel('closed', t)}
        sx={{
          fontFamily: value === 'closed' ? 'HalyardBold' : 'HalyardDisplay',
        }}
      />
    </Tabs>
  )
}
